import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { SideFiltersComponent } from './side-filters.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
    declarations: [
        SideFiltersComponent
    ],
    entryComponents: [
        SideFiltersComponent
    ],
    exports: [
        SideFiltersComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule
    ],
})
export class SideFiltersModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            SideFiltersComponent
        ]);
    }
}
